<template>
  <div class="header">
    <a href="/">
      <img src="@/assets/logo.svg" alt="">
    </a>
  </div>
</template>
<script>

export default {
  methods: {
  }
}
</script>